module.exports = __webpack_public_path__ + "img/kaoqin.51fd01b3.svg";